<template>
  <v-app class="whole">
    <div class="inside">
    <div class="myform">
      <div class="title-spaced">
        <v-layout wrap>
          <v-flex xs6 sm6 md6 text-left>
            <h2 class="text-left ">お買い物情報入力</h2>
          </v-flex>
          <v-flex xs6 sm6 md6 text-right>
            <v-chip class="white--text ml-0" color="indigo" label outlined small>個人のお客様</v-chip>
          </v-flex>
        </v-layout>
        <!-- <v-divider></v-divider> -->
        <small class="text-left ">商品のご購入の際にはお客様情報のご入力が必要です。<br></small>
      </div>
      <div class="question_spaced">
        <div class="titleCompany">お客様情報</div>
        <div class="tableSpace">
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-center"></th>
                <th class="text-center"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center">お名前</td>
                <td class="text-center">
                  <div class="inputForm_spaced">
                    <b-form-input type="text" v-model="inputForm.name" required 
                      placeholder="" @change="inCart"></b-form-input>
                    <small>例：佐々木 小次郎</small>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="text-center">住所</td>
                <td class="text-center">
                  <div class="inputForm_spaced">
                    <v-layout wrap>     
                      <v-flex xs6 sm6 md4 text-left>
                        <small >郵便番号</small>
                        <b-form-input type="text" v-model="inputForm.zipcode" required 
                          placeholder="" @change="inCart"></b-form-input>
                      </v-flex>
                      <v-flex xs6 sm6 md8 text-center></v-flex>
                    </v-layout>
                    <div class="formSpace2">
                      <small >住所</small>
                      <b-form-input type="text" v-model="inputForm.address" required 
                        placeholder="" @change="inCart"></b-form-input>
                    </div>
                    <div class="formSpace2">
                      <small >ビル名など</small>
                      <b-form-input type="text" v-model="inputForm.building" required 
                        placeholder="" @change="inCart"></b-form-input>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="text-center">電話番号</td>
                <td class="text-center">
                  <div class="inputForm_spaced">
                    <b-form-input type="text" v-model="inputForm.phone" required 
                      placeholder="" @change="inCart"></b-form-input>
                      <small>連絡の取れる電話番号を入力してください。</small>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="text-center">メールアドレス</td>
                <td class="text-center">
                  <div class="inputForm_spaced">
                    <b-form-input type="text" v-model="inputForm.mail" required 
                      placeholder="" @change="inCart"></b-form-input>
                      <small>お買い物情報をお知らせします。</small>
                  </div>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <!-- <div class="btnSet">
            <v-btn color="indigo" dark large rounded @click="confirm">
              <span class="material-icons">done</span><div class="btnText">登録する</div></v-btn>
          </div> -->
        </div>

        <div class="titleCompany">クレジットカード情報</div>
        <div class="tableSpace">
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-center"></th>
                <th class="text-center"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center">カード番号</td>
                <td class="text-center">
                  <div class="inputForm_spaced">
                    <b-form-input type="text" v-model="inputForm.credit_num" required 
                      placeholder="" @change="inCart"></b-form-input>
                    <!-- <small>例：佐々木 小次郎</small> -->
                  </div>
                </td>
              </tr>
              <tr>
                <td class="text-center">名義人</td>
                <td class="text-center">
                   <div class="inputForm_spaced">
                    <b-form-input type="text" v-model="inputForm.credit_name" required 
                      placeholder="" @change="inCart"></b-form-input>
                    <small>例：KOJIRO SASAKI</small>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="text-center">有効期限</td>
                <td class="text-center">
                  <div class="formSpace2">
                    <v-layout wrap>
                      <v-flex xs6 sm6 md6 text-left>
                        <small>月</small>
                        <div class="formNum">
                          <b-form-input type="number" v-model="inputForm.credit_month" required 
                            placeholder="" @change="inCart"></b-form-input>
                        </div>
                          <small>例：03</small>
                      </v-flex>
                      <v-flex xs6 sm6 md6 text-left>
                        <small>年</small>
                        <div class="formNum">
                          <b-form-input type="number" v-model="inputForm.credit_year" required 
                            placeholder="" @change="inCart"></b-form-input>
                        </div>
                          <small>例：2022</small>
                      </v-flex>
                    </v-layout>
                  </div>
                </td>
              </tr>
              
            </tbody>
          </v-simple-table>
          <div class="btnSet2">
            <v-btn color="indigo" block dark x-large  @click="confirm">
              <span class="material-icons">done</span><div class="btnText">確認する</div></v-btn>
              <div class="msg">{{ msg }}</div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex"
  export default {
    data() {
      return {
        inputForm: {},      
        msg: '',
        
      }
    },
    computed:{
      flag() {
        return this.isValid()
      }
    },
    mounted() {
     
    },
    methods: {
      inCart() {
        
      },
      confirm() {
        if(this.isValid()){
          this.$store.dispatch('cart/updateProfile', this.inputForm )
          this.$router.push({ name: 'confirm' })
        }else{
          this.msg = '全ての項目を入力して下さい。'
        }
      },
      isValid() {
        if( this.inputForm.name 
            && this.inputForm.zipcode 
            && this.inputForm.address
            && this.inputForm.phone 
            && this.inputForm.mail
            && this.inputForm.credit_num
            && this.inputForm.credit_name
            && this.inputForm.credit_month
            && this.inputForm.credit_year
          ){
        // if( typeof this.inputForm.name != 'undefined'
        //     && typeof this.inputForm.zipcode != 'undefined'
        //     && typeof this.inputForm.address != 'undefined'
        //     && typeof this.inputForm.phone != 'undefined'
        //     && typeof this.inputForm.mail != 'undefined'
        //     && typeof this.inputForm.credit_num != 'undefined'
        //     && typeof this.inputForm.credit_name != 'undefined'
        //     && typeof this.inputForm.credit_month != 'undefined'
        //     && typeof this.inputForm.credit_year != 'undefined'
        //   ){
            return true
        }else{
          return false
        }
      }
    },
  }
</script>
<style scoped>
  .whole {
      background-color: rgba(218, 218, 219, 0.2);
      color:#555555;
    }
    .inside {
      margin: 10%;
      padding: 0 0 0% 0;
      background-color: white;
      height: 100%;
    }
    @media screen and (min-width:896px){
        .inside {
          margin: 1% 10%;
        }
      }
  .myform{
   background-color: white;
    width: 80%;
    margin: 3% auto;
  }
  @media screen and (max-width:480px){
  /*画面幅が480pxまでの時*/
    .myform{
      width: 100%;
    }
  }
  /* @media screen and (min-width:781px){ */
  @media screen and (min-width:896px){
    /*画面幅が781px以上の時*/
    .myform{
      width: 50%;
    }
  }
  
  .mtb-medium{
    margin: 5% 0%;
  }
  .mb{
    margin-bottom: 3%
  }
  .b-form-group {
    margin: 15% 0%;
    padding: 15% 0%;
  }
  .btnSpace{
    width: 50%;
    margin: 10% auto;
  }
  @media screen and (min-width:896px){
    /*画面幅が781px以上の時*/
    .btnSpace{
      width: 30%;
      margin: 15% auto;
    }
  }
  .form-spaced{
    padding: 0% 0;
  }
  .title-spaced{
    padding: 0% 0;
  }
  .alert-spaced{
    padding: 3% 0 0 0;
    /* margin: 5% 0; */
  }
  .question_spaced{
    padding: 7% 0;
  }
  .question_inside_spaced{
    padding: 4% 0;
  }
  .spinbtn-spaced{
    padding: 0 5%;
  }
  .v-btn{
    text-decoration: none;
  }
  .stepper-text {
    color:#555555;
    font-size: 0.8rem;
  }
  .stepper-text-option {
    color:white;
    font-size: 0.6rem;
    padding: 7% 0;
  }
  .tableSpace {
    margin: 1% 0 17% 0;
  }
  .spinbtn-spaced{
    width: 60%;
    padding: 0 0% 0 0 ;
  }
  .inputForm_spaced {
    margin: 5% 10% 5% 0;
    text-align: left;
    color:#555555;
  }
  .formSpace2 {
    margin: 3% 0 0 0;
  }
  .titleCompany {
    font-size: 1.5rem;
    border-left: solid 7px #3c45bd;
    padding: 0 0  0 3% ;
  }
  .btnSet2 {
    margin: 15% 0;
    text-align: center;
    padding: 0 30%;
  }
  .btnText {
    margin: 0 0 0 10%;
  }
  .formNum {
    padding: 0 5% 0 0 ;
  }
  .msg {
    color: rgb(190, 15, 15);
    margin: 5% 0;
  }
</style>